function CourseBanner({
  title = "Course Title", 
  description = "A brief description of the course content.", 
  buttonText = "Start Learning Now",
  onButtonClick
}) 
{
  return (
    <div className="course-banner-bg">
      <div className="course-banner-content">
        <h1 className="course-banner-title">{title}</h1>
        <p className="course-banner-desc">{description}</p>
        <button className="navbar-signup" id="course-button" onClick={onButtonClick}>{buttonText}</button>
      </div>
    </div>
  );
}

export default CourseBanner;